import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RockThumbnailService } from '../../../services/rock-thumbnail/rock-thumbnail.service';
import { RemoveExtensionPipe } from '../../pipes/remove-extension.pipe';
import { RockFilePreviewData } from '../../../core/models/rock-file-preview.model';
import { RockImagesService } from '../../../services/rock-images/rock-images.service';
import { RockFile } from '../../../core/models/rock-files.model';
import { RockFileLoader } from '../../../utils/rock-file-loader.util';

@Component({
  selector: 'app-rock-file-preview-popup',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    RemoveExtensionPipe
],
  templateUrl: './rock-file-preview-popup.component.html',
  styleUrl: './rock-file-preview-popup.component.scss',
  standalone: true,
})
export class RockFilePreviewPopupComponent implements OnInit, OnDestroy {
  thumbnailUrl: string | null = null;
  rockFileMetadata: RockFile | null = null;
  isLoading = true;
  hasError = false;
  
  private rockFileLoader: RockFileLoader;

  constructor(
    public dialogRef: MatDialogRef<RockFilePreviewPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RockFilePreviewData,
    private rockThumbnailService: RockThumbnailService,
    private rockImagesService: RockImagesService
  ) {
    this.rockFileLoader = new RockFileLoader(rockThumbnailService, rockImagesService);
  }

  get totalPorosity(): string {
    const fractionHistogram = this.rockFileMetadata?.fractionHistogram;
    if (fractionHistogram && fractionHistogram['0'] != null) {
      const porosity = fractionHistogram['0'];
      return porosity.toFixed(2);
    }
    return 'N/A';
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    if (this.thumbnailUrl) {
      this.rockFileLoader.revokeThumbnailUrl(this.thumbnailUrl);
    }
  }

  loadData(): void {
    this.isLoading = true;
    this.hasError = false;

    // Load thumbnail (always works)
    this.rockFileLoader.getThumbnail(this.data.fileName).subscribe({
      next: (url) => {
        this.thumbnailUrl = url;
        this.isLoading = false;
        this.hasError = !url;
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
      }
    });

    this.rockFileLoader.getMetadata(this.data.fileName).subscribe({
      next: (metadata) => {
        this.rockFileMetadata = metadata;
      },
      error: () => {
        // Metadata not available, porosity will show N/A
        this.rockFileMetadata = null;
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
